import ModalColorizerSetupGroup from './ModalColorizerSetupGroup';
import ModalColorizerSetupSlider from './ModalColorizerSetupSlider';
import { ModalColorizerSetupHeader} from './ModalColorizerSetupHeader';
import type {ColorizeCategories} from './ModalColorizerSetupHeader';
import ModalColorizerSetupTools from './ModalColorizerSetupTools';
import Filter from '../FilterByParameters/Filter';
import ColorizerStorage from './ColorizerStorage';
import OverlayLayer from '../OverlayLayer/OverlayLayer';
import type {GData, SData, SDataRelatedOptions} from './types';
import type {API_ObjectAttributesType} from '../../types-telematics';
import './ModalColorizerSetup.scss';
import {featureGetRange} from './featureGetRange';
import type {GetRangeResponseType} from './featureGetRange';
import {WindowEffect} from "../WindowEffect/WindowEffect";
import {featureGetRelatedRange} from "./featureGetRelatedRange";

interface ModalColorizerSetupCallbacks {
    onSave: (data: GData | SData) => void;
    onCancel: () => void;
}

class ModalColorizerSetup extends ModalColorizerSetupTools {

    private mainRoot: HTMLDivElement;
    private root: HTMLDivElement;
    private overlay: any;
    private originalFilter: Filter;
    private handlerOnClickOutside: any | null = null;
    private objectTypes: API_ObjectAttributesType[];
    private selectedOption: string;
    private previousSelectedOption: string;
    private selectedPage: string;
    private useFilter: boolean;
    private modalColorizerSetupGroup: ModalColorizerSetupGroup;
    private modalColorizerSetupSlider: ModalColorizerSetupSlider;
    private modalColorizerSetupHeader: ModalColorizerSetupHeader;
    private callbacks: ModalColorizerSetupCallbacks;
    private isColorizerEnabled: boolean = true;
    private windowEffect: WindowEffect;

    constructor(
        mainRoot: HTMLDivElement,
        root: HTMLElement,
        originalFilter: Filter,
        colorizeData: GData | SData,
        callbacks: ModalColorizerSetupCallbacks
    ) {
        super();
        this.mainRoot = mainRoot;

        console.log('colorizeData', colorizeData);

        const isGData = (data: GData | SData): data is GData => {
            return !!(data as GData).groups;
        }

        const isSData = (data: GData | SData): data is SData => {
            return !!(data as SData).blocks;
        }

        this.selectedOption = colorizeData.selected_option;
        
        this.useFilter = false;

        if (isGData(colorizeData)) {
            ColorizerStorage.setGroupData(colorizeData, true);
        } else if (isSData(colorizeData)) {
            this.useFilter = colorizeData.use_filter;
            ColorizerStorage.setSliderData(colorizeData, true);
        } else {
            console.error('ModalColorizerSetup: colorizeData is not valid: ', colorizeData);
            throw new Error('ModalColorizerSetup: colorizeData is not valid');
        }
        
        this.overlay = OverlayLayer(
            'ModalColorizerSetup',
            {
                onClick: () => {
                    this.hide();
                }
            });

        root.innerHTML = `
        <div class="modal_colorizer_setup">
            <div class="container_for_arrows">
                <div class="container__arrow container__arrow--tl"></div>
            </div>
        </div>`;

        let el = root.querySelector('.modal_colorizer_setup') as HTMLDivElement;
        if (el) {
            this.root = el;
        } else {
            throw new Error('ModalColorizerSetup: root element not found');
        }
        this.root.style.display = 'none'; // hide by default
        this.setModalPosition();

        window.addEventListener('resize', () => {
            this.setModalPosition();
        });

        this.originalFilter = originalFilter;

        this.callbacks = callbacks;

        this.objectTypes = this.originalFilter.getAvailableTypes();

        this.previousSelectedOption = '';

        [ this.selectedPage, this.selectedOption ] = this.getSelectedPage2(this.selectedOption, this.originalFilter);

        this.modalColorizerSetupGroup = new ModalColorizerSetupGroup(
            this.mainRoot,
            this.originalFilter,
            {
                onSaveGroups: (gData) => {
                    console.info('groupData saved in localStorage', JSON.stringify(gData));
                    gData.selected_option = this.selectedOption;
                    ColorizerStorage.setGroupData(gData, true);
                    this.callbacks.onSave(gData);
                    this.hide();
                },
            });

        this.modalColorizerSetupSlider = new ModalColorizerSetupSlider(
            this.originalFilter,
            this.selectedOption,
            {
                onSaveSlider: (sData) => {
                    console.info('sliderData saved in localStorage', JSON.stringify(sData));
                    sData.selected_option = this.selectedOption;
                    ColorizerStorage.setSliderData(sData, true);
                    this.callbacks.onSave(sData);
                    this.hide();
                },
                onChangeSelectedType: (selectedType, resetSliderUserPeriods) => {
                    console.log('onChangeSelectedType, selectedType', selectedType); // OK
                    [ this.selectedPage, selectedType ] = this.getSelectedPage2(selectedType, this.originalFilter);
                    this.modalColorizerSetupHeader.changeSelectedOption(selectedType, resetSliderUserPeriods);
                    // this.reload();
                }
            });

        this.modalColorizerSetupHeader = new ModalColorizerSetupHeader(
            this.getColorizerMenuData(this.originalFilter),
            this.selectedOption,
            this.originalFilter.getSubMenu(),
            {
                onChangeSelect: (selectedOption, resetSliderUserPeriods) => {
                    this.selectedOption = selectedOption;
                    [ this.selectedPage, selectedOption ] = this.getSelectedPage2(selectedOption, this.originalFilter);
                    this.reload(resetSliderUserPeriods);
                },
                onChangeUseFilter: (useFilter) => {
                    // console.log('getQuantile, onChangeUseFilter, useFilter', useFilter); // OK
                    this.useFilter = useFilter;
                    this.modalColorizerSetupSlider.setLoadingMode(true);

                    if (this.selectedOptionIsRelated(this.selectedOption, this.originalFilter)) {
                            if (ColorizerStorage.getSData().selected_option === this.selectedOption) {
                                this.modalColorizerSetupSlider.setSliderData(ColorizerStorage.getSData());
                            }
                            this.modalColorizerSetupSlider.setLoadingMode(false, true);
                            this.renderSliderOutput();
                    } else {
                        this.modalColorizerSetupSlider.setLoadingMode(false, true);
                        this.modalColorizerSetupGroup.setUseFilter(useFilter);
                    }


                    // if (this.selectedOptionIsRelated(this.selectedOption, this.originalFilter)) {
                    //     featureGetRelatedRange.getRange(
                    //         this.getRelatedRangeOptions(
                    //             (colorizeData as SData).related_options
                    //         )
                    //     ).then( (data) => {
                    //         if (ColorizerStorage.getSData().selected_option === this.selectedOption) {
                    //             // console.debug('EEE, this.selectedOption === SData() ', this.selectedOption);
                    //             this.modalColorizerSetupSlider.setSliderData(ColorizerStorage.getSData());
                    //             // console.log('colorizeData, reload, current selected_option, getting data from ColorizerStorage, ColorizerStorage.getSData()',
                    //             //     this.modalColorizerSetupSlider.getSliderData()
                    //             // );
                    //         } else {
                    //             // console.debug('EEE, this.selectedOption <> SData() ', this.selectedOption);
                    //             this.modalColorizerSetupSlider.setDefaultData(
                    //                 this.selectedOption,
                    //                 data.range.min,
                    //                 data.range.max,
                    //                 this.originalFilter.getAvailableType(this.selectedOption).unit,
                    //                 (colorizeData as SData).related_options,
                    //                 true
                    //             );
                    //             // ColorizerStorage.getSData().selected_option = this.selectedOption;
                    //         }
                    //         this.modalColorizerSetupSlider.setUseFilter(this.useFilter, data.range.min, data.range.max);
                    //         this.modalColorizerSetupSlider.setLoadingMode(false, true);
                    //     }).catch( error => {
                    //         this.modalColorizerSetupSlider.setUseFilter(this.useFilter, 0, 0);
                    //         this.modalColorizerSetupSlider.setLoadingMode(false, false);
                    //     }).finally( () => {
                    //         this.renderSliderOutput();
                    //     });
                    // } else {
                    //     featureGetRange.getRange({
                    //         r: '',
                    //         f: this.selectedOption,
                    //         filter: (useFilter ? 1 : 0),
                    //         reset: 'f'
                    //     }).then(data => {
                    //         // console.log('onChangeUseFilter', data);
                    //         this.modalColorizerSetupSlider.setUseFilter(useFilter, data.range.c_min, data.range.c_max);
                    //         this.modalColorizerSetupSlider.setLoadingMode(false, true);
                    //     }).catch(error => {
                    //         console.error('onChangeUseFilter', error);
                    //         // alert('Nie udało się pobrać danych dla tego pola.');
                    //         this.modalColorizerSetupSlider.setUseFilter(useFilter, 0, 0);
                    //         this.modalColorizerSetupSlider.setLoadingMode(false, false);
                    //     }).finally(() => {
                    //         this.modalColorizerSetupGroup.setUseFilter(useFilter);
                    //     });
                    // }
                }
            });

        // console.log('allAvailableValues ModalColorizerSetup', this.originalFilter.getAvailableValuesAll());
        
        this.windowEffect = new WindowEffect(this.root, 'block');
        this.reload(true);
    }

    getRelatedRangeOptions( relatedOptions: SDataRelatedOptions ) {
        return {
            r: relatedOptions.related_collection,
            f: this.selectedOption,
            p: (relatedOptions.date_first) + '/' + (relatedOptions.compare_dates ? relatedOptions.date_second ?? '' : ''),
            fp: 'c_period',
        }
    }

    getColorizerMenuData(filter: Filter): ColorizeCategories {
        let categories : ColorizeCategories = {};
        let sliderKeys = filter.getTypeKeysColorableSlider();
        let groupKeys = filter.getTypeKeysColorableGroup();
        let usedKeys: string[] = [];
        
        // Get fields from groups
        Object.entries(filter.getFilterGroups().group).forEach( ([groupId, group]) => {
            group.fld.forEach( (field) => {
                if (sliderKeys.indexOf(field) === -1 && groupKeys.indexOf(field) === -1) {
                    return;
                    // categories['Inne'].push({id: field, label: filter.getNameForItemKey(field)});
                    // usedKeys.push(field);
                } else {
                    if (categories[group.label] === undefined) {
                        categories[group.label] = [];
                    }
                    categories[group.label].push({id: field, label: filter.getNameForItemKey(field)});
                    usedKeys.push(field);
                }
            });
        });


        // Add not used fields in filter columns and groups but defined as colorable
        [...sliderKeys, ...groupKeys].forEach( (key) => {
            // console.debug('getColorizerMenuData, key', key);
            if (usedKeys.indexOf(key) === -1) {
                if (sliderKeys.indexOf(key) === -1 && groupKeys.indexOf(key) === -1) {
                    console.warn('ColorizerStorage, getColorizerMenuData, key not found in filter columns and groups but defined as colorable', key);
                    return;
                } else {
                    if (categories['Pozostałe'] === undefined) {
                        categories['Pozostałe'] = [];
                    }
                    categories['Pozostałe'].push({
                        id: key,
                        label: filter.getNameForItemKey(key),
                    })
                    usedKeys.push(key);
                }
            } else {
                // console.warn('ColorizerStorage, getColorizerMenuData, key already used', key);
            }
        });

        console.debug('getColorizerMenuData, categories', categories);
        return categories;
    }


    getSliderData() {
        return this.modalColorizerSetupSlider.getSliderData();
    }

    setSliderData(sliderData) {
        return this.modalColorizerSetupSlider.setSliderData(sliderData);
    }

    show(): void {
        if (!this.isColorizerEnabled) {
            console.warn('Colorizer is not enabled for this collection. Check $_CFG in the console for colorable options.');
            alert('Colorizer is not enabled for this collection.');
            return;
        }
        this.selectedOption = ColorizerStorage.getSelectedOption();
        if (typeof this.selectedOption === 'undefined' || this.selectedOption === null)  {
            this.selectedOption = this.originalFilter.getTypeKeysColorableSlider()[0];
        }
        [ this.selectedPage, this.selectedOption ] = this.getSelectedPage2(this.selectedOption, this.originalFilter);
        this.reload(false);
        this.overlay.show();
        this.setModalPosition();
        this.windowEffect.show();
    }

    setModalPosition() {
        this.root.style.left = '250px';
        this.root.style.top = '114px';
    }

    hide() {
        this.windowEffect.hide();
        this.overlay.hide();
    }

    reload(resetSliderUserPeriods: boolean) {
        console.debug('ModalColorizerSetup, reload, this.selectedOption, resetSliderUserPeriods', this.selectedOption, resetSliderUserPeriods);
        [ this.selectedPage, this.selectedOption ] = this.getSelectedPage2(this.selectedOption, this.originalFilter);

        // Set event when user click outside the modal, then cancel all changes and close window
        if (this.handlerOnClickOutside === null) {
            this.handlerOnClickOutside = (e: MouseEvent) => {
                if (e.target === this.root) {
                    this.hide();
                    this.callbacks.onCancel();
                }
            };
            this.root.addEventListener('click', this.handlerOnClickOutside);
        }

        switch (this.selectedPage) {
            case 'colorize_slider': {
                this.modalColorizerSetupHeader.reload(this.selectedOption, this.useFilter);
                this.modalColorizerSetupHeader.setUseFilterCheckboxEnabled(true);
                this.modalColorizerSetupSlider.setLoadingMode(true);

                // IF RELATED !!!
                if (this.selectedOptionIsRelated(this.selectedOption, this.originalFilter)) {
                    this.modalColorizerSetupHeader.setUseFilterCheckboxEnabled(false);
                    let relatedOptions = (ColorizerStorage.getSData() as SData).related_options;
                    let fld = this.originalFilter.getAvailableType(this.selectedOption);
                    if (true) { // default related options if not set
                        if (relatedOptions.date_first === null) {
                            relatedOptions.date_first = fld.period_range.max;
                            relatedOptions.related_collection = fld.collection;
                            // this.modalColorizerSetupSlider.getSliderData().setRelatedOptions(relatedOptions);
                        }
                    }
                    featureGetRelatedRange.getRange(
                        this.getRelatedRangeOptions(
                            relatedOptions,
                        )
                    ).then( (data) => {
                        if (ColorizerStorage.getSData().selected_option === this.selectedOption) { // if selected option is like last one
                            this.modalColorizerSetupSlider.setSliderData(ColorizerStorage.getSData());
                        } else { // if user change selected option
                            this.modalColorizerSetupSlider.setDefaultData(
                                this.selectedOption,
                                data.range.min,
                                data.range.max,
                                this.originalFilter.getAvailableType(this.selectedOption).unit,
                                relatedOptions,
                                resetSliderUserPeriods
                            );
                            // ColorizerStorage.getSData().selected_option = this.selectedOption;
                        }
                        this.modalColorizerSetupSlider.setUseFilter(this.useFilter, data.range.min, data.range.max);
                        this.modalColorizerSetupSlider.setLoadingMode(false, true);
                    }).catch( error => {
                        console.error(error);
                        this.modalColorizerSetupSlider.setUseFilter(this.useFilter, 0, 0);
                        this.modalColorizerSetupSlider.setLoadingMode(false, false);
                    }).finally( () => {
                        this.renderSliderOutput();
                    });

                } else { // IF NOT RELATED

                    featureGetRange.getRange({
                        r: '',
                        f: this.selectedOption,
                        filter: (this.useFilter ? 1 : 0),
                        reset: 'f'
                    }).then((data: GetRangeResponseType) => {
                        if (typeof(this.originalFilter.getSubMenu()[this.selectedOption]) !== 'undefined') {
                            let subMenuItems = this.originalFilter.getSubMenu()[this.selectedOption].items;
                            if (subMenuItems.length > 0) {
                                this.selectedOption = subMenuItems.map( item => item.id ).includes(ColorizerStorage.getSData().selected_option) ? ColorizerStorage.getSData().selected_option : subMenuItems[0].id;
                            }
                        }
                        if (ColorizerStorage.getSData().selected_option === this.selectedOption) {
                            this.modalColorizerSetupSlider.setSliderData(ColorizerStorage.getSData());
                            // this.modalColorizerSetupSlider.setSelectedType(this.selectedOption);
                        } else {
                            let min = this.originalFilter.getAvailableType(this.selectedOption).min;
                            let max = this.originalFilter.getAvailableType(this.selectedOption).max;
                            this.modalColorizerSetupSlider.setDefaultData(
                                this.selectedOption,
                                min,
                                max,
                                this.originalFilter.getAvailableType(this.selectedOption).unit,
                                { // set empty values, bcs not used
                                    date_first: null,
                                    date_second: null,
                                    compare_dates: false,
                                    related_collection: null,
                                },
                                resetSliderUserPeriods
                            );
                            // ColorizerStorage.getSData().selected_option = this.selectedOption;
                        }
                        this.modalColorizerSetupSlider.setUseFilter(this.useFilter, data.range.c_min, data.range.c_max);
                        this.modalColorizerSetupSlider.setLoadingMode(false, true);
                    }).catch(error => {
                        console.error(error);
                        this.modalColorizerSetupSlider.setUseFilter(this.useFilter, 0, 0);
                        this.modalColorizerSetupSlider.setLoadingMode(false, false);
                    }).finally(() => {
                        this.renderSliderOutput();
                    })
                }
                break;
            }
            case 'colorize_group': {
                this.modalColorizerSetupHeader.reload(this.selectedOption, false);
                this.modalColorizerSetupHeader.setUseFilterCheckboxEnabled(false);
                this.modalColorizerSetupGroup.setSelectedType(this.selectedOption);
                if (ColorizerStorage.getGData().selected_option === this.selectedOption) {
                    this.modalColorizerSetupGroup.setData(ColorizerStorage.getGData());
                } else {
                    this.modalColorizerSetupGroup.setSelectedType(this.selectedOption);
                    this.modalColorizerSetupGroup.setDefaultData();
                }
                this.root.innerHTML = `<div class="telematics-colorize_setup colorize_group">
                    <div class="container_for_arrows">
                        <div class="container__arrow container__arrow--tl"></div>
                    </div>
                </div>`;
                let el_colorize_setup = this.root.querySelector('.telematics-colorize_setup');
                if (el_colorize_setup) {
                    el_colorize_setup.appendChild((this.modalColorizerSetupHeader).getElement());
                    el_colorize_setup.appendChild((this.modalColorizerSetupGroup).getElement());
                }
                break;
            }
            default:
                console.error('ModalColorizerSetup, Unrecognized page: ' + this.selectedPage + ' for option ' + this.selectedOption);
        }

    }

    selectedOptionIsRelated(selectedOption: string, filter: Filter): boolean {
        let output = false;
        let availableType = filter.getAvailableType(selectedOption);
        if (availableType && availableType.can_be_related) {
            output = true;
        }
        return output;
    }

    renderSliderOutput() {
        this.root.innerHTML = `
                        <div class="telematics-colorize_setup colorize_slider">
                            <div class="container_for_arrows">
                                <div class="container__arrow container__arrow--tl"></div>
                            </div>
                        </div>`;
        let el_colorize_setup = this.root.querySelector('.telematics-colorize_setup');
        if (el_colorize_setup) {
            el_colorize_setup.appendChild((this.modalColorizerSetupHeader).getElement());
            el_colorize_setup.appendChild((this.modalColorizerSetupSlider).getElement());
        }
    }
}

export default ModalColorizerSetup;